module.exports = __webpack_public_path__ + "static/media/banner-re2-md.efdef6de.png";